import * as React from "react"
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Input,
  Text,
  useClipboard,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react"
import Head from "next/head"
import { HomeLayout } from "components/HomeLayout"
import splitbee from "@splitbee/web"
import { Chrono } from "react-chrono"

// Splitbee.js
splitbee.track("Rollout")

export default function Rollout() {
  const [value, setValue] = React.useState(
    "addr1q8vczftecp45segsjvy2pk3fz3zc6s02np3d4ukyc7wp3dp6mhxrefruqptr93usqs0eqqlluueulx5ee8zd9xyq95mq4qqs5q",
  )
  const { hasCopied, onCopy } = useClipboard(value)

  const [valuePolicy, setValuePolicy] = React.useState(
    "d17b9b240ee5953793c4cfb6b490ab69b6dbc0a4c5bb0698e534849c",
  )
  const { hasCopied: hasCopiedPolicy, onCopy: onCopyPolicy } = useClipboard(valuePolicy)

  return (
    <Box>
      <Head>
        <title>ROAMpool Rollout</title>
      </Head>

      <VStack
        py={{ base: 10, md: 16 }}
        spacing={{ base: 8, md: 10 }}
        align={"center"}
        direction={"column"}
        px={8}
      >
        <Heading py={{ base: 10, md: 16 }} size={"2xl"}>
          Rollout Plan
        </Heading>
        <Text textAlign={"justify"}>
          ROAMpool has 1000 llamas to be released to the wild, here's our the plan.
        </Text>
      </VStack>

      <Timeline />

      <Box py={100}>
        <Heading size="2xl" py={100} align={"center"}>
          FAQ
        </Heading>
        <Accordion allowMultiple allowToggle>
          <AccordionItem>
            <AccordionButton>
              <AccordionIcon />
              Why do we require 1000₳+ to be qualified for the awards?
            </AccordionButton>
            <AccordionPanel>
              We want delegators to put some skin in the game, believe in Cardano.
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <AccordionButton>
              <AccordionIcon />
              Why equal winning chance among qualified delegators?
            </AccordionButton>
            <AccordionPanel>
              This is our way to encourage decentralization. This method gives smaller delegators a much
              bigger winning chance and avoids all the NFT awards being concentrated on a few "whales".
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <AccordionButton>
              <AccordionIcon />
              How do I improve my chance of winning?
            </AccordionButton>
            <AccordionPanel>
              Stake with us early as possible. The earlier you are, the more chances to win!
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <AccordionButton>
              <AccordionIcon />
              What is the buy back guarantee?
            </AccordionButton>
            <AccordionPanel>
              If you decide that you don't want a token of appreciation to show you supported the
              decentralization movement, then we will gladly buy the NFT back for 100₳. DM our Twitter and
              transmit NFT to us at the address below.
              <Container
                mt={50}
                mb={50}
                maxW={"3xl"}
                boxShadow={"xl"}
                rounded={"lg"}
                bgGradient={"linear(to-b, green.50, green.100)"}
                p={6}
                direction={"column"}
              >
                <Flex mb={2}>
                  <Input color={useColorModeValue("gray.500", "whiteAlpha.700")} value={value} isReadOnly />
                  <Button onClick={onCopy} ml={2}>
                    {hasCopied ? "Address copied" : "Copy"}
                  </Button>
                  <Button
                    as="a"
                    href="https://cardanoscan.io/address/addr1q8vczftecp45segsjvy2pk3fz3zc6s02np3d4ukyc7wp3dp6mhxrefruqptr93usqs0eqqlluueulx5ee8zd9xyq95mq4qqs5q"
                    ml={2}
                  >
                    Visit
                  </Button>
                </Flex>
              </Container>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <AccordionButton>
              <AccordionIcon />
              How do we tell whether a NFT is real and authentic from ROAM?
            </AccordionButton>
            <AccordionPanel>
              For it to be authentic and forged Llama from ROAM, the NFT must have a token policy of
              <Container
                mt={50}
                mb={50}
                maxW={"3xl"}
                boxShadow={"xl"}
                rounded={"lg"}
                bgGradient={"linear(to-b, green.50, green.100)"}
                p={6}
                direction={"column"}
              >
                <Flex mb={2}>
                  <Input
                    color={useColorModeValue("gray.500", "whiteAlpha.700")}
                    value={valuePolicy}
                    isReadOnly
                  />
                  <Button onClick={onCopyPolicy} ml={2}>
                    {hasCopiedPolicy ? "Copied policy" : "Copy"}
                  </Button>
                  <Button
                    as="a"
                    href="https://cardanoscan.io/tokenPolicy/d17b9b240ee5953793c4cfb6b490ab69b6dbc0a4c5bb0698e534849c"
                    ml={2}
                  >
                    Visit
                  </Button>
                </Flex>
              </Container>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
    </Box>
  )
}

Rollout.getLayout = (page: React.ReactNode) => <HomeLayout>{page}</HomeLayout>

export const Timeline = () => {
  const items = [
    {
      title: "Winter 2022",
      cardTitle: "Llamas #1 - 100",
      cardSubtitle: "ROAMpool delegators exclusive",
      cardDetailedText: [
        "  Only these come with a 100₳ buy back guarantee! This means... these NFTs are as good as" +
          " cold hard C₳SH! ",
        " Starting on Jan. 1st, any delegator with 1000₳+ staked with us are eligible for air-dropped NFT.",
        "All eligible delegators have equal chance to win.",
      ],
    },
    {
      title: "Spring 2022",
      cardTitle: "Llamas #101 - 200",
      cardSubtitle: "Released for sale at 100-200₳ pricing depending on rarity.",
      cardDetailedText: [
        "Unfortunately if the initial 100 llamas run out, they're gone! But hey, look, 100 new llamas!",
        "Eligible delegators get 50% price discount!",
      ],
    },
    {
      title: "Summer 2022",
      cardTitle: "Llamas #201 - 1000",
      cardSubtitle: "Reserved...",
      cardDetailedText: "Roam back here later!",
    },
  ]

  return (
    <Chrono
      items={items}
      mode="VERTICAL"
      scrollable
      hideControls
      useReadMore={false}
      theme={{
        primary: "gray",
        secondary: "gray",
        cardBgColor: "white",
        cardForeColor: "black",
        titleColor: "black",
      }}
    />
  )
}
